/* eslint-disable pii/no-phone-number */
import PropTypes from "prop-types";
import React from "react";
import { FormattedNumber, FormattedDate, FormattedMessage } from "react-intl";
import accounting from "accounting";
import moment from "moment";

export const UNLIMITED_AMOUNT = 999999999999;
export const UNLIMITED_AMOUNT_SYMBOL = "--";
// Setting Sum Assured currency to '$' since there's no current configuration available to set this (Marky Mark)
export const formatWithHardcodedCurrency = value => accounting.formatMoney(value, "$");

export const FormattedMoney = ({
  value,
  postfix = false,
  isRaw = false,
  symbol: currencySymbol,
  currency,
  alwaysUnlimited = false,
  ...props
}) => {
  if (accounting.unformat(value) === UNLIMITED_AMOUNT || alwaysUnlimited) {
    return <FormattedMessage id="Unlimited" defaultMessage="Unlimited" />;
  }
  const number = accounting.unformat(value);
  const symbol = currencySymbol || currency;
  // remove empty or falsy currency props so we don't pass invalid values in
  // and override default currency (sanity check in case configs have empty values like https://cxagroup.atlassian.net/browse/APL-1478)
  // if postfix, use currency string like 5 SGD not S$5. Fall back to the one that is given though. symbol takes place over currency code
  return postfix ? (
    <span>
      {accounting.formatMoney(number, {
        ...(symbol ? { symbol } : {}),
        ...(isRaw ? { precision: 0 } : {}),
        format: accounting.getPostfixCurrencyFormat(),
      })}
    </span>
  ) : (
    <FormattedNumber
      value={number}
      format="money"
      currencyDisplay="code"
      currency={symbol}
      {...props}
    />
  );
};

FormattedMoney.propTypes = {
  value: PropTypes.any.isRequired, //either '$100' or 100
  currency: PropTypes.string,
  symbol: PropTypes.string,
  postfix: PropTypes.any,
  isRaw: PropTypes.bool,
  alwaysUnlimited: PropTypes.bool,
};

export const FormattedCustomDate = ({ value, customFormat = "", format, ...props }) => {
  if (!moment(value).isValid()) {
    return <span>-</span>;
  }

  if (format) {
    return <FormattedDate value={value} format={format} {...props} />;
  }

  if (value) {
    return <span>{moment(value).format(customFormat)}</span>;
  }

  return null;
};
FormattedCustomDate.propTypes = {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  customFormat: PropTypes.string,
};

//might remove these eventually to reduce footprints
export const FormattedShortDate = ({ value, ...props }) => (
  <FormattedCustomDate value={value} format="short" {...props} />
);
FormattedShortDate.propTypes = {
  value: PropTypes.any,
};

export const FormattedMediumDate = ({ value, ...props }) => (
  <FormattedCustomDate value={value} format="medium" {...props} />
);
FormattedMediumDate.propTypes = {
  value: PropTypes.any,
};



// WEBPACK FOOTER //
// ./components/common/FormattedComponents.js